module.exports = __webpack_public_path__ + "static/media/top-slide-3.9dd90e6b.jpeg";